import DOMPurify from "dompurify";
import {StatsReport as DashboardIcon} from "iconoir-react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {useTranslation} from "react-i18next";
import {PageTitle} from "../common/PageTitle";

export const PortalHome = () =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation(['translation', 'override']);

    const sanitizeHTML = (html : string) => {
        return {__html: DOMPurify.sanitize(html)};
    }

    return (
        <>
            <Row>
                <div className="d-flex flex-row align-items-center border-bottom pb-2 mb-4">
                    <div className="d-flex justify-content-start">
                        <PageTitle title={t(["override:portal.home.title", "portal.home.title"])} icon={<DashboardIcon />}/>
                    </div>
                </div>
            </Row>

            <Row className="h-100 w-100 overflow-auto">
                <Col md={12} className="max-page-width">
                    <div dangerouslySetInnerHTML={sanitizeHTML(t(["override:portal.home.content", "portal.home.content"]))} />
                </Col>
            </Row>
        </>
    )
}
